import Subtitle from "components/Subtitle/subtitle.component";
import dompurify from "dompurify";
import { LoadingStyle } from "pages/comum/Layout/layout.style";
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import GenericAlert from "../../../components/Alert/genericAlert.component";
import Button from "../../../components/Button/button.component";
import Label from "../../../components/Label/label.component";
import MapGeo from "../../../components/Map/map.component";
import Title from "../../../components/Title/title.component";
import { Creators as GeoActions } from "../../../store/ducks/alertas/geo";

class VisualizarGeo extends Component {
	state = {
		mapKey: 0,
		loading: false
	};

	componentDidMount() {
		const { geoActions, alertaId } = this.props;
		const { mapKey } = this.state;

		this.setLoading(true);
		geoActions.geoBuscarPorAlertaId(alertaId, () => {
			this.setState({ mapKey: mapKey + 1, loading: false });
		});
	}

	setLoading(loading) {
		this.setState({ loading });
	}

	innerHTMLPurified = text => {
		const textToBeSanitizer = text;
		const sanitizer = dompurify.sanitize;
		// eslint-disable-next-line react/no-danger
		return (
			<span
				dangerouslySetInnerHTML={{
					__html: sanitizer(textToBeSanitizer) || " "
				}}
			/>
		);
	};

	render() {
		const {
			geoActions,
			alertaId,
			geoCadastrados,
			geoCadastrados: { alertaStatus },
			onClick,
			handleBackButton,
			responsavel,
			dataAcao,
			responsavelEmissao,
			dataHoraEmissao
		} = this.props;
		const { mapKey } = this.state;
		return (
			<div className="mt-3">
				{this.state.loading && (
					<LoadingStyle className="loading">
						<div className="text-center">
							<div className="spinner-border" role="status" />
						</div>
					</LoadingStyle>
				)}
				{
					<GenericAlert
						type="primary"
						body={
							<div>
								<Subtitle style={{ color: "#134265" }}>
									Informações sobre o alerta
								</Subtitle>
								<div
									className="row"
									style={{ paddingTop: "15px" }}
								>
									<Label
										label="Status"
										text={
											((alertaStatus || {}).status || {})
												.nome || " ---"
										}
										col={4}
									/>

									<Label
										label={
											((alertaStatus || {}).status || {})
												.nome === "Ativo"
												? "Data/Hora da emissão"
												: "Data/Hora"
										}
										text={
											((alertaStatus || {}).status || {})
												.nome === "Ativo"
												? dataHoraEmissao
												: dataAcao
										}
										col={4}
									/>

									<Label
										label="Responsável"
										text={
											((alertaStatus || {}).status || {})
												.nome === "Ativo"
												? responsavelEmissao
												: responsavel
										}
										col={4}
									/>
								</div>
								{(((alertaStatus || {}).status || {}).nome ===
									"Cessado" ||
									((alertaStatus || {}).status || {}).nome ===
										"Cancelado") && (
									<div className="row">
										<Label
											label="Mensagem"
											text={this.innerHTMLPurified(
												(alertaStatus || {}).mensagem ||
													" ---"
											)}
										/>
									</div>
								)}
							</div>
						}
					/>
				}
				<Title>Georreferenciamento dos municípios afetados</Title>
				<hr />
				<div className="text-center card">
					<MapGeo
						alertaId={alertaId}
						GeoActions={geoActions}
						geoCadastrados={geoCadastrados}
						key={mapKey}
						isVisualizar
					/>
				</div>
				<div className="row mt-3">
					<div className="col-md-6">
						<div className="float-left">
							<Button
								type="button"
								cancel
								text="Sair"
								icon="fas fa-times"
								onClick={() => handleBackButton()}
							/>
							<Button
								onClick={() => onClick("dados")}
								type="submit"
								primary
								text="Voltar"
								icon="fas fa-arrow-left"
							/>
						</div>
					</div>
					<div className="col-md-6">
						<div className="float-right">
							<Button
								onClick={() => onClick("analise")}
								type="submit"
								primary
								text="Próximo"
								icon="fas fa-arrow-right"
							/>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => ({
	geoCadastrados: state.geo.geo,
	responsavel: state.geo.responsavel,
	dataAcao: state.geo.dataAcao,
	responsavelEmissao: state.geo.responsavelEmissao,
	dataHoraEmissao: state.geo.dataHoraEmissao
});

const mapDispatchToProps = dispatch => ({
	geoActions: bindActionCreators(GeoActions, dispatch)
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(VisualizarGeo);
